import api from './api';

export const getCheckPost = async (text) => {
    try {

        let resposta = await api.post(`CheckPost`,{text:text});

        return resposta;
    } catch (error) {

            return error;

    }
};
